
































import Vue from 'vue'
import { QcqDialogData } from '@/types'

interface ComponentData {
  codeValidationRules: Array<Function>
  languageValidationRules: Array<Function>
}

export default Vue.extend({
  name: 'QcqDialog',

  props: {
    dialogTitle: String,
    dialogData: {
      type: Object as () => QcqDialogData
    },
    openDialog: Boolean,
    isSaveButtonDisabled: Boolean
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      codeValidationRules: [
        required
      ],
      languageValidationRules: [
        required
      ],
    }
  },

  watch: {
    openDialog (newVal: boolean): void {
      if (newVal) {
        const form: any = this.$refs['form']
        if(form) {
          form.resetValidation()
        }
      }
    }
  },

  methods: {
    onDialogClose (): void {
      this.$emit('onCloseDialog')
    },

    onDialogSave (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        this.$emit('onSaveData')
      }
    }
  }
})
